import { jsx as _jsx } from "react/jsx-runtime";
export function LoadingState({ ariaLabel = 'Loading...', className }) {
    return (_jsx("div", { className: `d-flex align-items-center justify-content-center p-4 ${className || ''}`.trim(), "aria-busy": "true", "aria-live": "polite", children: _jsx("span", { className: "spinner-border", role: "status", "aria-label": ariaLabel }) }));
}
//# sourceMappingURL=LoadingState.js.map